import { render, staticRenderFns } from "./LoveBase.vue?vue&type=template&id=4e30e628&scoped=true&"
import script from "./LoveBase.vue?vue&type=script&lang=js&"
export * from "./LoveBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e30e628",
  null
  
)

export default component.exports